import './fonts.css';
import './housecanary.css';
import './icons.css';
import './inputs.css';
export const DesignSystemStyles = () => {
  return null;
};
